// // src/pages/VolunteerLoginGoogle.jsx
// import React, { useState } from "react";
// import { auth, db, googleProvider } from "../firebase";
// import { signInWithPopup } from "firebase/auth";
// import { ref, get } from "firebase/database";
// import { useNavigate } from "react-router-dom";
// import { saveSessionRole } from "../roles";

// export default function VolunteerLoginGoogle() {
//   const [pin, setPin] = useState("");
//   const [err, setErr] = useState("");
//   const nav = useNavigate();

//   async function login() {
//     setErr("");
//     try {
//       const cred = await signInWithPopup(auth, googleProvider);
//       const email = cred.user.email?.toLowerCase() || "";
//       // Admin must pre-create volunteer with this email and a PIN
//       const key = btoa(email);
//       const snap = await get(ref(db, `volunteersByEmail/${key}`));
//       if (!snap.exists()) { setErr("Not a registered volunteer. Ask admin to add your email."); return; }
//       const v = snap.val();
//       if (!pin || v.pin !== pin) { setErr("Invalid PIN."); return; }
//       // minimal session
//       sessionStorage.setItem("festumVolunteer", JSON.stringify({ id: v.id, name: v.name || cred.user.displayName || "", email }));
//       nav("/volunteer/checkin");
//       // After validating volunteersByEmail + PIN:
// saveSessionRole("volunteer", { id: v.id, name: v.name, email });

//     } catch (e) {
//       setErr(e.message);
//     }
//   }

//   return (
//     <div className="max-w-md mx-auto bg-white rounded-2xl shadow p-6 space-y-4">
//       <h1 className="text-2xl font-bold">Volunteer Login</h1>
//       <button onClick={login} className="w-full py-3 rounded-xl border hover:bg-gray-50">Continue with Google</button>
//       <input className="w-full p-3 border rounded-xl" placeholder="Volunteer PIN" value={pin} onChange={(e)=>setPin(e.target.value)} type="password" />
//       {err && <div className="text-red-600 text-sm">{err}</div>}
//       <p className="text-xs text-gray-500">Your Google email must be pre-approved by admin and you must know the PIN.</p>
//     </div>
//   );
// }

import React, { useState } from "react";
import { auth, db, googleProvider } from "../firebase";
import { signInWithPopup } from "firebase/auth";
import { ref, get } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { saveSessionRole } from "../roles";

export default function VolunteerLoginGoogle() {
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const nav = useNavigate();

  async function login() {
    setErr("");
    try {
      const cred = await signInWithPopup(auth, googleProvider);
      const email = (cred.user.email || "").toLowerCase();
      const key = btoa(email);
      const snap = await get(ref(db, `volunteersByEmail/${key}`));
      if (!snap.exists()) { setErr("Not a registered volunteer. Ask admin to add you."); return; }
      const v = snap.val();
      if (v.pin !== pin) { setErr("Invalid PIN."); return; }
      saveSessionRole("volunteer", { id: v.id, name: v.name || cred.user.displayName || "", email });
      nav("/volunteer/teams");
    } catch (e) {
      setErr(e.message);
    }
  }

  return (
    <div className="max-w-md mx-auto bg-white rounded-2xl shadow p-6 space-y-4">
      <h1 className="text-2xl font-bold">Volunteer Login</h1>
      <button onClick={login} className="w-full py-3 rounded-xl border hover:bg-gray-50">Continue with Google</button>
      <input className="w-full p-3 border rounded-xl" placeholder="Volunteer PIN" value={pin} onChange={(e)=>setPin(e.target.value)} type="password" />
      {err && <div className="text-red-600 text-sm">{err}</div>}
      <p className="text-xs text-gray-500">Your Google email must be pre-approved and you must know the PIN.</p>
    </div>
  );
}
